/**
 * User Collateral State Module
 *
 * Provides functionality to fetch complete user position state across all subaccounts.
 */

// Types
export type { BorrowPosition, CollateralPosition, LtvConfig, UserCollateralState } from './types'

// Hook for fetching user state
export { useUserCollateralState } from './useUserCollateralState'
export type { UseUserCollateralStateParams, UseUserCollateralStateResult } from './useUserCollateralState'
